import { Group } from './../../svg';
import { deepExtend } from './../../utils/deep-extend';
export class AdornerBase {
    constructor(diagram, options) {
        this.diagram = diagram;
        this.options = deepExtend({}, this.options, options);
        this.visual = new Group();
        this.diagram._adorners.push(this);
    }
    refresh() { }
}
